const ProfileModule = {
  components: {
    Adsense,
  },
  mixins: [ProfileValidation],
  computed: {
    ...Vuex.mapState([
      'user',
      'profile',
      'services',
      'sectors',
      'studies',
      'languages',
      'schedules',
      'availability',
    ]),
    pending() {
      return this.user.status === 'active' && this.profile.status === 'pending';
    },
    errors() {
      return Object.keys(this.$v.profile).filter(
        (key) =>
          !['experience', 'education'].includes(key) &&
          this.$v.profile[key].$invalid,
      );
    },
    onlyMissesSchedules() {
      return this.errors.length === 1 && this.errors[0] === 'schedules';
    },
  },
  watch: {
    profile: {
      deep: true,
      immediate: false,
      handler(values, old) {
        this.profile.status = this.errors.length ? 'pending' : 'active';
      },
    },
  },
  created: function () {
    this.$dmtk.profile.get().then((data) => {
      this.$store.commit('set', data);
    });
    this.$on('profile.save', function () {
      if (this.onlyMissesSchedules) {
        this.profile.schedules = ['week.morning', 'week.evening'];
      }

      this.profile.description = this.profile.description?.trim();
      this.profile.experience = this.profile.experience?.trim();
      this.profile.education = this.profile.education?.trim();

      return this.$dmtk.profile.save(this.profile).then((profile) => {
        let user = domestiko.user;
        user.username = profile.display_name;
        this.user.username = profile.display_name;
        this.$store.commit('user', this.user);
        domestiko.login(user);

        this.profile.status = profile.status;
        this.$store.commit('profile', this.profile);

        window.scrollTo(0, 0);
        customAlert(
          'Se han modificado tus datos',
          profile.status === 'active'
            ? 'Actualizaremos tu perfil público en unos minutos.'
            : profile.status === 'inactive'
            ? 'Por favor verifica tu correo electrónico para que podamos activar tu perfil.'
            : 'Por favor completa correctamente tu perfil para que podamos activarlo.',
        );
      });
    });
    domestiko.$on('user.loggedout', () => {
      location = '/';
    });
  },
  template: `
      <div>
        <div class="uk-alert uk-alert-danger uk-flex" v-if="pending">
          <span class="icon icon-warning"></span>
          <p v-if="onlyMissesSchedules">
            Por favor <router-link to="/perfil/disponibilidad">rellena tu disponibilidad</router-link> para poder inscribirte a las ofertas.
          </p>
          <p v-else>Tu perfil no está activo. Para poder inscribirte a las ofertas necesitas completar tus datos.</p>
        </div>
        <ul class="uk-subnav uk-subnav-divider uk-margin-medium-bottom" uk-margin>
          <li>
            <router-link to="/perfil/informacion">Información</router-link>
            <em class="uk-pin" v-if="$v.info_required.$invalid"></em>
            <em class="uk-pin -warning" v-else-if="$v.info_recommended.$invalid"></em>
          </li>
          <li>
            <router-link to="/perfil/experiencia">
              <span v-if="profile.type !== 'E'">Experiencia</span>
              <span v-if="profile.type === 'E'">Actividad</span>
              <em class="uk-pin" v-if="$v.experience_required.$invalid"></em>
              <em class="uk-pin -warning" v-else-if="$v.experience_recommended.$invalid"></em>
            </router-link>
          </li>
          <li>
            <router-link to="/perfil/notificaciones">Localización</router-link>
            <em class="uk-pin" v-if="$v.alerts_required.$invalid"></em>
            <em class="uk-pin -warning" v-else-if="$v.alerts_recommended.$invalid"></em>
          </li>
          <li>
            <router-link to="/perfil/disponibilidad">Disponibilidad</router-link>
            <em class="uk-pin" v-if="$v.availability_required.$invalid"></em>
            <em class="uk-pin -warning" v-else-if="$v.availability_recommended.$invalid"></em>
          </li>
          <li v-if="profile.status === 'active'">
            <router-link to="/perfil/servicios">
              Tablón
              <em class="uk-pin" v-if="services.length === 0"></em>
            </router-link>
          </li>
          <li v-if="profile.status === 'active'">
            <router-link to="/perfil/compartir">
              Comparte tu perfil
            </router-link>
          </li>
        </ul>
        <router-view></router-view>
      </div>
	`,
};
